import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';

import { GameStateEnum, GameModel } from '../../Models/GameModel';
import { ButtonController, IButtonControllerOptions } from '../../Common/ButtonController';
import { IToggleButtonControllerOptions, ToggleButtonController } from '../../Common/ToggleButtonController';
import { GameLogic } from '../../Logic/GameLogic';
import { LivesLogic } from '../../Logic/LivesLogic';
import { ModalsNames } from '../../Common/MadalsManager/ModalsList';
import { SoundModel } from '../../Models/SoundModel';
import {
    GameEvent,
    GameEventPopupButtonName,
    GameEventPopupName,
    GameEventSceneButtonClick,
} from '../../Constants/GameEvent';

export class SettingsMenuController extends AnimationBaseController {
    $model: GameModel;

    public opened: boolean = false;

    public constructor(
        @Inject private _options: any,
        @Inject private _gameLogic: GameLogic,
        @Inject private _livesLogic: LivesLogic,
        @Inject private _modelEvents: ModelEvents,
        @Inject private _model: GameModel,
    ) {
        super('SettingsMenuController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            childControllers: {
                btn_settings: {
                    instanceName: 'btn_settings',
                    controller: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => this.changeOpened(!this.opened),
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    protected changeOpened(state: boolean): void {
        this.opened = state;
        this.gotoAndStop(this.opened ? 'open' : 'close');

        this.removeChildControllerByName('btn_music');
        this.removeChildControllerByName('btn_sound');
        this.removeChildControllerByName('btn_exit');

        if (this.opened) {
            this._modelEvents.dispatch(this._model, GameEvent.popupOpen, { popupName: 'Settings' });

            this.addChildController({
                instanceName: 'btn_exit',
                controller: ButtonController,
                options: <IButtonControllerOptions>{
                    onClick: (status: boolean) => {
                        this._modelEvents.dispatch(this._model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.settings, buttonName: GameEventPopupButtonName.cancel, status });

                        if (!status) {
                            return;
                        }

                        this.changeOpened(!this.opened);
                        this._options.onClickExit(status);
                    },
                },
            }, 'btn_exit');

            if (!this._options.hideExitButton) {
                this.$childControllers.get('btn_exit').visible = true;
            } else {
                this.$childControllers.get('btn_exit').visible = false;
            }

            this.addChildController({
                instanceName: 'btn_music',
                controller: ToggleButtonController,
                options: <IToggleButtonControllerOptions>{
                    onOff: SoundModel.music !== 0,
                    onClick: () => {
                        this._gameLogic.setMusicOnOff((this.$childControllers.get('btn_music') as ToggleButtonController).onOff);
                        console.log('SoundModel.music', SoundModel.music);

                        this._modelEvents.dispatch(this._model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.settings, buttonName: GameEventPopupButtonName.music });
                    },
                },
            }, 'btn_music');

            this.addChildController({
                instanceName: 'btn_sound',
                controller: ToggleButtonController,
                options: <IToggleButtonControllerOptions>{
                    onOff: SoundModel.UI !== 0,
                    onClick: () => {
                        this._gameLogic.setSoundOnOff((this.$childControllers.get('btn_sound') as ToggleButtonController).onOff);
                        this._modelEvents.dispatch(this._model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.settings, buttonName: GameEventPopupButtonName.sound });
                    },
                },
            }, 'btn_sound');
        }
    }
}
